import React from "react";
import AppointmentItem from "./appointment";
import { useHistory } from "react-router-dom";
import arrow from "../../assets/images/arrows_left_icon.png";
import arrowNext from "../../assets/images/arrow_left_icon.png";
import { useQuery } from "@apollo/client";
import { GET_ALL_APPOINTMENTS } from "queries/queries";
import { GET_PHARMACY_PROJECTS } from "queries/queries";
import Loading from "components/loading";
import Error from "components/error";
import NoResultPage from "components/thankyou/noresult-page";
import useMakeScrollable from "custom_hooks/make-scrollable";

const AppointmentsList = ({ }) => {
  useMakeScrollable();
  let history = useHistory();
  const { loading, error, data } = useQuery(GET_ALL_APPOINTMENTS, {
    fetchPolicy: "no-cache",
  });

  const pharmacyProjects = useQuery(GET_PHARMACY_PROJECTS, {
    fetchPolicy: "no-cache",
  });


  if (loading || pharmacyProjects.loading) return <Loading />;
  if (error || pharmacyProjects.error) return <Error />;

  const suggestedProjects = pharmacyProjects?.data?.getPharmacyProjects
  const appointments = data?.getAllAppointments

  if (!suggestedProjects.length && !appointments.length) {
    return <NoResultPage text="Aktuell sind leider keine neuen Schulungen für dich verfügbar." />
  }

  return (
    <div className="appointments scrollable">
      {!!appointments.length && <div className="appointment-next">
        <div>Dein nächster Termin</div>
        {appointments?.map((appointment) => (
          <AppointmentItem
            key={appointment.id}
            next={true} 
            arrow={arrowNext}
            onClick={() => {
              history.push({
                pathname: `/appointment-details/${appointment.id}`,
                state: { appointmentId: appointment.id }
              });
            }}
            project={appointment} 
          />
        ))}
      </div>}
      {!!suggestedProjects.length && <div className="appointments-next">
        <div>Verfügbare Schulungen</div>
          {suggestedProjects?.map((project) => (
            <AppointmentItem
              key={project.project.id}
              next={false}
              arrow={arrow}
              project={project}
              onClick={() => history.push('/appointments-suggestion')}
              requestSend={project.requestSend}
            />
          ))}
      </div>}
    </div>
  );
  };
  
  export default AppointmentsList;
  